const BASE_COLORS = {
  'base-transparent': ' rgba(255, 255, 255, 0.00)',
  'base-black': '#000000',
  'base-mastercomponent': '#9661ff'
};

const CORE_COLORS = {
  // Spring Yellow
  'spring-yellow-15': '#fefffa',
  'spring-yellow-25': '#fdfff5',
  'spring-yellow-50': '#fcffef',
  'spring-yellow-100': '#f5ffcd',
  'spring-yellow-200': '#f0ffb4',
  'spring-yellow-200-alt': '#f0ffb4',
  'spring-yellow-300': '#eaff92',
  'spring-yellow-400': '#e5ff7d',
  'spring-yellow-500': '#dfff5d',
  'spring-yellow-525': '#d4f551',
  'spring-yellow-550': '#cfef4d',
  'spring-yellow-600': '#cbe855',
  'spring-yellow-700': '#9eb542',
  'spring-yellow-800': '#7b8c33',
  'spring-yellow-900': '#5e6b27',
  'spring-yellow-1000': '#4f5a21',
  'spring-yellow-1100': '#424b1b',
  'spring-yellow-1200': '#353c16',
  'spring-yellow-1300': '#1a1e0b',
  'spring-yellow-1400': '#d5ee64',

  // Spring Yellow Alpha
  'spring-yellow-alpha-15': ' rgba(205, 255, 5, 0.02)',
  'spring-yellow-alpha-25': ' rgba(205, 255, 5, 0.04)',
  'spring-yellow-alpha-50': ' rgba(213, 255, 26, 0.07)',
  'spring-yellow-alpha-100': ' rgba(205, 255, 5, 0.20)',
  'spring-yellow-alpha-200': ' rgba(205, 255, 5, 0.30)',
  'spring-yellow-alpha-300': ' rgba(204, 255, 0, 0.43)',
  'spring-yellow-alpha-400': ' rgba(204, 255, 0, 0.51)',
  'spring-yellow-alpha-500': ' rgba(204, 255, 0, 0.64)',
  'spring-yellow-alpha-525': ' rgba(194, 242, 2, 0.69)',
  'spring-yellow-alpha-550': ' rgba(187, 233, 1, 0.70)',
  'spring-yellow-alpha-600': ' rgba(179, 223, 1, 0.67)',
  'spring-yellow-alpha-700': ' rgba(125, 155, 3, 0.75)',
  'spring-yellow-alpha-800': ' rgba(92, 112, 0, 0.80)',
  'spring-yellow-alpha-900': ' rgba(66, 81, 1, 0.85)',
  'spring-yellow-alpha-1000': ' rgba(55, 69, 3, 0.88)',
  'spring-yellow-alpha-1100': ' rgba(45, 54, 2, 0.90)',
  'spring-yellow-alpha-1200': ' rgba(35, 44, 2, 0.92)',
  'spring-yellow-alpha-1300': ' rgba(15, 19, 1, 0.96)'
};

const NEUTRAL_COLORS = {
  // White
  'white-50': '#ffffff',
  'white-100': '#fcfcfc',
  'white-200': '#fafafa',
  'white-300': '#f7f7f7',
  'white-400': '#f2f2f2',
  'white-500': '#ededed',
  'white-600': '#e8e8e8',
  'white-700': '#b5b5b5',
  'white-800': '#8c8c8c',
  'white-900': '#6b6b6b',

  // Cloud
  'cloud-50': '#fdfdfd',
  'cloud-100': '#f8f8f8',
  'cloud-200': '#f5f5f5',
  'cloud-300': '#f0f0f0',
  'cloud-400': '#ededed',
  'cloud-500': '#e9e9e9',
  'cloud-600': '#d4d4d4',
  'cloud-700': '#a5a5a5',
  'cloud-800': '#808080',
  'cloud-900': '#626262',
  'cloud-1000': '#525252',
  'cloud-1100': '#3d3d3d',
  'cloud-1200': '#292929',
  'cloud-1300': '#141414',

  // Cloud Alpha
  'cloud-alpha-50': ' rgba(56, 56, 56, 0.01)',
  'cloud-alpha-100': ' rgba(23, 23, 23, 0.03)',
  'cloud-alpha-200': ' rgba(5, 5, 5, 0.04)',
  'cloud-alpha-300': ' rgba(5, 5, 5, 0.06)',
  'cloud-alpha-400': ' rgba(31, 31, 31, 0.08)',
  'cloud-alpha-500': ' rgba(10, 10, 10, 0.09)',
  'cloud-alpha-600': ' rgba(3, 3, 3, 0.17)',
  'cloud-alpha-700': ' rgba(5, 5, 5, 0.36)',
  'cloud-alpha-800': ' rgba(0, 0, 0, 0.50)',
  'cloud-alpha-900': ' rgba(3, 3, 3, 0.62)',
  'cloud-alpha-1000': ' rgba(0, 0, 0, 0.68)',
  'cloud-alpha-1100': ' rgba(3, 3, 3, 0.77)',
  'cloud-alpha-1200': ' rgba(0, 0, 0, 0.84)',

  // Stone
  'stone-25': '#fdfcfc',
  'stone-50': '#fbfaf9',
  'stone-100': '#f3f0ec',
  'stone-200': '#eee8e2',
  'stone-300': '#e6ded5',
  'stone-400': '#e1d8cd',
  'stone-500': '#d9cec1',
  'stone-600': '#c5bbb0',
  'stone-700': '#9a9289',
  'stone-800': '#77716a',
  'stone-900': '#5b5751',
  'stone-1000': '#4c4843',
  'stone-1100': '#413e3a',
  'stone-1200': '#2b2926',
  'stone-1300': '#161513',

  // Charcoal
  'charcoal-50': '#eaeaeb',
  'charcoal-75': '#d8d8da',
  'charcoal-100': '#bdbec0',
  'charcoal-200': '#9d9fa1',
  'charcoal-300': '#707376',
  'charcoal-400': '#55585c',
  'charcoal-425': '#393f46',
  'charcoal-475': '#30353b',
  'charcoal-500': '#2a2e33',
  'charcoal-600': '#262a2e',
  'charcoal-700': '#1e2124',
  'charcoal-800': '#17191c',
  'charcoal-900': '#121315',
  'charcoal-1000': '#0f0f0f',

  // Charcoal Alpha
  'charcoal-alpha-50': 'rgba(22, 22, 34, 0.09)', // #161622 at 9% opacity
  'charcoal-alpha-75': 'rgba(8, 11, 24, 0.16)', // #080B18 at 16% opacity
  'charcoal-alpha-100': 'rgba(1, 5, 14, 0.26)', // #01050E at 26% opacity
  'charcoal-alpha-200': 'rgba(4, 10, 16, 0.39)', // #040A10 at 39% opacity
  'charcoal-alpha-300': 'rgba(4, 10, 16, 0.5)', // #040A10 at 50% opacity
  'charcoal-alpha-400': 'rgba(1, 7, 14, 0.67)', // #01070E at 67% opacity
  'charcoal-alpha-425': 'rgba(1, 10, 19, 0.78)', // #010A13 at 78% opacity
  'charcoal-alpha-475': 'rgba(3, 10, 17, 0.82)', // #030A11 at 82% opacity
  'charcoal-alpha-500': 'rgba(1, 7, 14, 0.84)', // #01070E at 84% opacity
  'charcoal-alpha-600': 'rgba(3, 7, 12, 0.86)', // #03070C at 86% opacity
  'charcoal-alpha-700': 'rgba(2, 6, 8, 0.89)', // #020608 at 89% opacity
  'charcoal-alpha-750': 'rgba(10, 10, 10, 0.8)', // #0A0A0A at 80% opacity
  'charcoal-alpha-800': 'rgba(0, 2, 5, 0.91)', // #000205 at 91% opacity
  'charcoal-alpha-900': 'rgba(0, 2, 5, 0.93)', // #000205 at 93% opacity
  

  // Pebble
  'pebble-50': '#eeeeed',
  'pebble-100': '#c9c9c8',
  'pebble-200': '#afafae',
  'pebble-300': '#8a8a89',
  'pebble-400': '#737472',
  'pebble-500': '#50514f',
  'pebble-600': '#494a48',
  'pebble-700': '#393a38',
  'pebble-800': '#2c2d2b',
  'pebble-900': '#222221',
  'pebble-1000': '#1c1c1c',
  'pebble-1100': '#1a1a19',
  'pebble-1200': '#171717',
  'pebble-1300': '#151514'
};

const SEMANTIC_COLORS = {
  'info-10': '#f5fefe',
  'info-15': '#f0fdfe',
  'info-25': '#e6fbfe',
  'info-50': '#dcfafe',
  'info-100': '#ccf7fe',
  'info-200': '#9aeafd',
  'info-300': '#68d5f9',
  'info-400': '#42bdf4',
  'info-500': '#0798ed',
  'info-600': '#0576cb',
  'info-700': '#0358aa',
  'info-800': '#023e89',
  'info-900': '#012c71',
  'info-1000': '#012560',
  'info-1100': '#011f51',
  'info-1200': '#011941',
  'info-1330': '#011332',
  'info-1300': '#010f28',

  'success-10': '#f9fef5',
  'success-15': '#f6fef1',
  'success-25': '#f1fde7',
  'success-50': '#ebfdde',
  'success-100': '#e6fcd6',
  'success-200': '#ccfaaf',
  'success-300': '#a7f184',
  'success-400': '#83e363',
  'success-500': '#53d134',
  'success-600': '#50b326',
  'success-700': '#22961a',
  'success-800': '#127910',
  'success-900': '#146409',
  'success-1000': '#125908',
  'success-1100': '#0f4b07',
  'success-1200': '#0b3805',
  'success-1300': '#082503',

  'warning-10': '#fffef5',
  'warning-15': '#fefbe6',
  'warning-25': '#fefadc',
  'warning-50': '#fef9d7',
  'warning-100': '#fef8cf',
  'warning-200': '#feefa0',
  'warning-300': '#fee471',
  'warning-400': '#fdd84e',
  'warning-500': '#fcc614',
  'warning-600': '#d8a40e',
  'warning-700': '#b5850a',
  'warning-800': '#926706',
  'warning-900': '#785203',
  'warning-1000': '#644402',
  'warning-1100': '#503602',
  'warning-1200': '#3c2901',
  'warning-1300': '#281b01',

  'danger-10': '#f4aeb2',
  'danger-15': '#f3a5aa',
  'danger-25': '#f29ca2',
  'danger-50': '#f09399',
  'danger-100': '#ef8a94',
  'danger-200': '#ec747f',
  'danger-300': '#e85465',
  'danger-400': '#e54353',
  'danger-500': '#dd2c3f',
  'danger-600': '#d32234',
  'danger-700': '#b82837',
  'danger-800': '#9f2d38',
  'danger-900': '#873039',
  'danger-1000': '#762e35',
  'danger-1100': '#642b31',
  'danger-1200': '#512a2d',
  'danger-1300': '#412528',

  'danger-alpha-10': ' rgba(222, 2, 13, 0.32)',
  'danger-alpha-15': ' rgba(225, 5, 19, 0.36)',
  'danger-alpha-25': ' rgba(223, 1, 16, 0.39)',
  'danger-alpha-50': ' rgba(220, 4, 19, 0.43)',
  'danger-alpha-100': ' rgba(218, 1, 23, 0.46)',
  'danger-alpha-200': ' rgba(222, 2, 24, 0.55)',
  'danger-alpha-300': ' rgba(220, 4, 30, 0.68)',
  'danger-alpha-400': ' rgba(218, 1, 23, 0.74)',
  'danger-alpha-500': ' rgba(213, 1, 22, 0.83)',
  'danger-alpha-600': ' rgba(203, 1, 21, 0.87)',
  'danger-alpha-700': ' rgba(172, 2, 19, 0.85)',
  'danger-alpha-800': ' rgba(141, 2, 16, 0.83)',
  'danger-alpha-900': ' rgba(109, 3, 13, 0.82)',
  'danger-alpha-1000': ' rgba(87, 0, 9, 0.82)',
  'danger-alpha-1100': ' rgba(69, 3, 9, 0.84)',
  'danger-alpha-1200': ' rgba(50, 1, 5, 0.84)',
  'danger-alpha-1300': ' rgba(34, 2, 5, 0.86)',

  'warning-alpha-10': ' rgba(255, 230, 5, 0.04)',
  'warning-alpha-15': ' rgba(245, 217, 5, 0.10)',
  'warning-alpha-25': ' rgba(250, 221, 5, 0.14)',
  'warning-alpha-50': ' rgba(250, 217, 5, 0.16)',
  'warning-alpha-100': ' rgba(247, 215, 2, 0.19)',
  'warning-alpha-200': ' rgba(252, 215, 3, 0.38)',
  'warning-alpha-300': ' rgba(254, 207, 1, 0.56)',
  'warning-alpha-400': ' rgba(252, 198, 3, 0.70)',
  'warning-alpha-500': ' rgba(252, 194, 3, 0.93)',
  'warning-alpha-600': ' rgba(213, 160, 1, 0.95)',
  'warning-alpha-700': ' rgba(182, 131, 2, 0.97)',
  'warning-alpha-800': ' rgba(142, 100, 1, 0.98)',
  'warning-alpha-900': ' rgba(117, 78, 0, 0.99)',
  'warning-alpha-1000': '#644402',
  'warning-alpha-1100': '#503602',
  'warning-alpha-1200': '#3c2901',
  'warning-alpha-1300': '#281b01',

  'success-alpha-10': ' rgba(106, 230, 5, 0.04)',
  'success-alpha-15': ' rgba(105, 238, 23, 0.06)',
  'success-alpha-25': ' rgba(114, 235, 15, 0.10)',
  'success-alpha-50': ' rgba(100, 239, 1, 0.13)',
  'success-alpha-100': ' rgba(106, 236, 14, 0.17)',
  'success-alpha-200': ' rgba(95, 240, 5, 0.32)',
  'success-alpha-300': ' rgba(74, 226, 3, 0.49)',
  'success-alpha-400': ' rgba(55, 211, 3, 0.62)',
  'success-alpha-500': ' rgba(40, 198, 1, 0.80)',
  'success-alpha-600': ' rgba(51, 166, 3, 0.86)',
  'success-alpha-700': ' rgba(10, 137, 1, 0.90)',
  'success-alpha-800': ' rgba(3, 111, 1, 0.94)',
  'success-alpha-900': ' rgba(14, 96, 1, 0.97)',
  'success-alpha-1000': ' rgba(12, 87, 0, 0.97)',
  'success-alpha-1100': ' rgba(10, 70, 2, 0.98)',
  'success-alpha-1200': ' rgba(9, 54, 2, 0.99)',
  'success-alpha-1300': ' rgba(6, 36, 0, 0.99)',

  'info-alpha-10': '#0ce6e60a', // rgba(5, 230, 230, 0.04)
  'info-alpha-15': '#05e0f00f', // rgba(5, 224, 240, 0.06)
  'info-alpha-25': '#05d5f519', // rgba(5, 213, 245, 0.10)
  'info-alpha-50': '#05ddfa24', // rgba(5, 221, 250, 0.14)
  'info-alpha-100': '#00d9fa33', // rgba(0, 217, 250, 0.20)
  'info-alpha-200': '#03cffc66', // rgba(3, 207, 252, 0.40)
  'info-alpha-300': '#02baf799', // rgba(2, 186, 247, 0.60)
  'info-alpha-400': '#02aaf2bf', // rgba(2, 170, 242, 0.75)
  'info-alpha-500': '#0297edfa', // rgba(2, 151, 237, 0.98)
  'info-alpha-600': '#0273cafc', // rgba(2, 115, 202, 0.99)
  'info-alpha-700': '#0057a8fc', // rgba(0, 87, 168, 0.99)
  'info-alpha-800': '#023e88', // rgba(2, 62, 136, 1)
  'info-alpha-900': '#012b6f', // rgba(1, 43, 111, 1)
  'info-alpha-1000': '#012560', // rgba(1, 37, 96, 1)
  'info-alpha-1100': '#011f51', // rgba(1, 31, 81, 1)
  'info-alpha-1200': '#011941', // rgba(1, 25, 65, 1)
  'info-alpha-1330': '#011332', // rgba(1, 19, 50, 1)
  'info-alpha-1300': '#010f28' // rgba(1, 15, 40, 1)
};

const SUPPORTING_COLORS = {
  'green-spruce-15': '#f8fcfb',
  'green-spruce-25': '#f0f9f8',
  'green-spruce-50': '#eaf7f5',
  'green-spruce-100': '#bfe6e0',
  'green-spruce-200': '#9fdad1',
  'green-spruce-300': '#74c9bb',
  'green-spruce-400': '#59bfae',
  'green-spruce-500': '#2faf9a',
  'green-spruce-600': '#2b9f8c',
  'green-spruce-700': '#217c6d',
  'green-spruce-800': '#1a6055',
  'green-spruce-900': '#144a41',
  'green-spruce-1000': '#114038',
  'green-spruce-1100': '#0e342e',
  'green-spruce-1200': '#0b2823',
  'green-spruce-1300': '#09201c',
  'green-pine-15': '#f5faf9',
  'green-pine-25': '#eef6f6',
  'green-pine-50': '#e6f2f1',
  'green-pine-100': '#b1d5d3',
  'green-pine-200': '#8bc1be',
  'green-pine-300': '#56a5a0',
  'green-pine-400': '#35948d',
  'green-pine-500': '#037971',
  'green-pine-600': '#036e67',
  'green-pine-700': '#025650',
  'green-pine-800': '#02433e',
  'green-pine-900': '#01332f',
  'green-pine-1000': '#012d29',
  'green-pine-1100': '#012825',
  'green-pine-1200': '#012320',
  'green-pine-1300': '#011e1c',
  'green-forest-green-15': '#e6ebeb',
  'green-forest-green-25': '#e6ebeb',
  'green-forest-green-50': '#e6ebeb',
  'green-forest-green-100': '#b1c0c1',
  'green-forest-green-200': '#8ba2a3',
  'green-forest-green-300': '#557778',
  'green-forest-green-400': '#355d5e',
  'green-forest-green-500': '#023436',
  'green-forest-green-600': '#022f31',
  'green-forest-green-700': '#012526',
  'green-forest-green-800': '#011d1e',
  'green-forest-green-900': '#011617',
  'green-forest-green-1000': '#011314',
  'green-forest-green-1100': '#010e0f',
  'green-forest-green-1200': '#00090a',
  'green-forest-green-1300': '#000505',
  'green-forest-green-475': '#144143',
  'green-forest-green-alpha-15': ' rgba(30, 82, 82, 0.04)',
  'green-forest-green-alpha-25': ' rgba(12, 54, 54, 0.07)',
  'green-forest-green-alpha-50': ' rgba(5, 56, 56, 0.10)',
  'green-forest-green-alpha-100': ' rgba(3, 51, 53, 0.26)',
  'green-forest-green-alpha-200': ' rgba(3, 52, 53, 0.46)',
  'green-forest-green-alpha-300': ' rgba(1, 53, 55, 0.67)',
  'green-forest-green-alpha-400': ' rgba(3, 52, 53, 0.80)',
  'green-forest-green-alpha-475': ' rgba(2, 52, 54, 0.93)',
  'green-forest-green-alpha-500': '#023436',
  'green-forest-green-alpha-600': '#022f31',
  'green-forest-green-alpha-700': '#012628',
  'green-forest-green-alpha-800': '#011d1e',
  'green-forest-green-alpha-900': '#011718',
  'green-forest-green-alpha-1000': '#011313',
  'green-forest-green-alpha-1100': '#010d0e',
  'green-forest-green-alpha-1200': '#00090a',
  'green-forest-green-alpha-1300': '#000505',
  'purple-plum-15': '#fcfbfe',
  'purple-plum-25': '#f5f4fb',
  'purple-plum-50': '#f0eef9',
  'purple-plum-100': '#d1cbed',
  'purple-plum-200': '#bab2e5',
  'purple-plum-300': '#9b8fd9',
  'purple-plum-400': '#8879d1',
  'purple-plum-500': '#6a58c6',
  'purple-plum-600': '#6050b4',
  'purple-plum-700': '#4b3e8d',
  'purple-plum-800': '#3a306d',
  'purple-plum-900': '#2d2553',
  'purple-plum-1000': '#261f47',
  'purple-plum-1100': '#1f1938',
  'purple-plum-1200': '#17132a',
  'purple-plum-1300': '#0f0d1c',
  'purple-haze-15': '#f6f6f8',
  'purple-haze-25': '#f1f1f4',
  'purple-haze-50': '#ececf0',
  'purple-haze-100': '#c3c4d2',
  'purple-haze-200': '#a5a8bc',
  'purple-haze-300': '#7c809d',
  'purple-haze-400': '#63678a',
  'purple-haze-500': '#3c416d',
  'purple-haze-600': '#373b63',
  'purple-haze-700': '#2b2e4d',
  'purple-haze-800': '#21243c',
  'purple-haze-900': '#191b2e',
  'purple-haze-1000': '#161728',
  'purple-haze-1100': '#121321',
  'purple-haze-1200': '#0e101a',
  'purple-haze-1300': '#0b0c14',
  'purple-blackberry-15': '#f7f7f8',
  'purple-blackberry-25': '#f1f1f4',
  'purple-blackberry-50': '#e9e9ed',
  'purple-blackberry-100': '#bbbbc6',
  'purple-blackberry-200': '#9a9aaa',
  'purple-blackberry-300': '#6c6c84',
  'purple-blackberry-400': '#4f4f6c',
  'purple-blackberry-500': '#232347',
  'purple-blackberry-600': '#202041',
  'purple-blackberry-700': '#191932',
  'purple-blackberry-800': '#131327',
  'purple-blackberry-900': '#0f0f1e',
  'purple-blackberry-1000': '#0e0e1b',
  'purple-blackberry-1100': '#0c0c18',
  'purple-blackberry-1200': '#0a0a14',
  'purple-blackberry-1300': '#090911',
  'red-scarlet-15': '#fffafa',
  'red-scarlet-25': '#fef6f5',
  'red-scarlet-50': '#feefee',
  'red-scarlet-100': '#fbcecb',
  'red-scarlet-200': '#f9b6b2',
  'red-scarlet-300': '#f6958e',
  'red-scarlet-400': '#f58179',
  'red-scarlet-500': '#f26157',
  'red-scarlet-600': '#dc584f',
  'red-scarlet-700': '#ac453e',
  'red-scarlet-800': '#853530',
  'red-scarlet-900': '#662925',
  'red-scarlet-1000': '#5a2421',
  'red-scarlet-1100': '#3c1816',
  'red-scarlet-1200': '#2d1210',
  'red-scarlet-1300': '#1e0c0b',
  'red-redwood-15': '#fcf8f8',
  'red-redwood-25': '#faf5f5',
  'red-redwood-50': '#f6ecec',
  'red-redwood-100': '#e4c5c5',
  'red-redwood-200': '#d7a9a9',
  'red-redwood-300': '#c58181',
  'red-redwood-400': '#b96969',
  'red-redwood-500': '#a84343',
  'red-redwood-600': '#993d3d',
  'red-redwood-700': '#773030',
  'red-redwood-800': '#5c2525',
  'red-redwood-900': '#471c1c',
  'red-redwood-1000': '#3b1717',
  'red-redwood-1100': '#2c1111',
  'red-redwood-1200': '#250e0e',
  'red-redwood-1300': '#1d0c0c',
  'red-ceder-15': '#f8f7f7',
  'red-ceder-25': '#f3f1f2',
  'red-ceder-50': '#edeaeb',
  'red-ceder-100': '#c8bdc1',
  'red-ceder-200': '#ad9da3',
  'red-ceder-300': '#877178',
  'red-ceder-400': '#70555e',
  'red-ceder-500': '#4c2b36',
  'red-ceder-600': '#452731',
  'red-ceder-700': '#361f26',
  'red-ceder-800': '#2a181e',
  'red-ceder-900': '#201217',
  'red-ceder-1000': '#1d1115',
  // 'red-ceder-1000': ' rgba(14, 2, 5, 0.94)',
  'red-ceder-1100': '#1a0f13',
  'red-ceder-alpha-15': ' rgba(82, 56, 56, 0.04)',
  'red-ceder-alpha-25': ' rgba(55, 22, 38, 0.06)',
  'red-ceder-alpha-50': ' rgba(55, 22, 33, 0.09)',
  'red-ceder-alpha-100': ' rgba(45, 1, 18, 0.26)',
  'red-ceder-alpha-200': ' rgba(47, 4, 20, 0.39)',
  'red-ceder-alpha-300': ' rgba(40, 1, 13, 0.56)',
  'red-ceder-alpha-400': ' rgba(40, 1, 14, 0.67)',
  'red-ceder-alpha-500': ' rgba(43, 3, 16, 0.87)',
  'red-ceder-alpha-600': ' rgba(35, 1, 13, 0.85)',
  'red-ceder-alpha-700': ' rgba(26, 0, 8, 0.88)',
  'red-ceder-alpha-800': ' rgba(19, 1, 7, 0.91)',
  'red-ceder-alpha-900': ' rgba(15, 0, 6, 0.93)',
  'red-ceder-alpha-1000': ' rgba(14, 2, 5, 0.94)',
  'red-ceder-alpha-1100': ' rgba(13, 2, 7, 0.95)'
};

// MISSING COLOR FROM THE DESIGN SYSTEM.
// Will go through when Asif is back.
const CUSTOM_COLORS = {
  'blue-sky-200': '#b4dbff',
  'green-mint-200': '#3ac0a0',
  'grey-200': '#F1F2F3',
  'beige-50': '#F7F5F2'
};

// Type exports
export type Colors =
  | typeof BASE_COLORS
  | typeof CORE_COLORS
  | typeof NEUTRAL_COLORS
  | typeof SEMANTIC_COLORS
  | typeof SUPPORTING_COLORS
  | typeof CUSTOM_COLORS;

export type ColorToken = keyof typeof COLORS;

const COLORS = {
  ...BASE_COLORS,
  ...CORE_COLORS,
  ...NEUTRAL_COLORS,
  ...SEMANTIC_COLORS,
  ...SUPPORTING_COLORS,
  ...CUSTOM_COLORS
};

export default COLORS;
